import { render, staticRenderFns } from "./AbilityDetail.vue?vue&type=template&id=bbeed866&scoped=true&"
import script from "./AbilityDetail.vue?vue&type=script&lang=js&"
export * from "./AbilityDetail.vue?vue&type=script&lang=js&"
import style0 from "./AbilityDetail.vue?vue&type=style&index=0&id=bbeed866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeed866",
  null
  
)

export default component.exports